import { Reveal, Eyebrow } from "./Reveal";
import { SITE } from "../config";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-surface border-y border-line">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="max-w-3xl">
          <Reveal>
            <div className="flex items-baseline gap-4">
              <span className="font-heading text-xl text-accent">06</span>
              <Eyebrow>About</Eyebrow>
            </div>
            <h2 className="mt-6 font-heading font-medium tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl text-ink">
              Hi, I'm {SITE.fullName.split(" ")[0]}.
            </h2>
            <p className="mt-6 text-base md:text-lg text-stone leading-relaxed max-w-xl">
              I'm a freelance web developer focused on creating modern, customised
              websites for businesses and entrepreneurs.
            </p>
            <p className="mt-4 text-base md:text-lg text-stone leading-relaxed max-w-xl">
              I combine design thinking, web development and AI-assisted tools to
              turn ideas into polished digital experiences — without the overhead
              of a traditional agency.
            </p>
            <p className="mt-8 font-heading italic text-2xl text-ink/70">
              — {SITE.fullName}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
